module.exports = __webpack_public_path__ + "media/images/es_419/connect_dots-52e741fbc873584e558fb062528c61b9.png";